import { render } from "./VModal.vue?vue&type=template&id=3f914abd&ts=true"
import script from "./VModal.vue?vue&type=script&lang=ts"
export * from "./VModal.vue?vue&type=script&lang=ts"

import "./VModal.vue?vue&type=style&index=0&id=3f914abd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__